module.exports = __webpack_public_path__ + "static/media/48_B.492229d4.png";